import * as types from '../types.js';

export default {

	html: `
		<style>
			#move-location-bulk .company	{ width: 11rem;	}
			#move-location-bulk .warehouse	{ width: 10rem;	}
			#move-location-bulk .location	{ width: 14rem;	}
			#move-location-bulk #movement_kind { width: 20rem; }
			#move-location-bulk #reason		{ width: 22rem;	}
		</style>
		<form id="move-location-bulk" class="form" autocomplete="off" novalidate>
			<datalist id="mlb-companies">
			</datalist>
			<datalist id="mlb-source-warehouses">
			</datalist>
			<datalist id="mlb-target-warehouses">
			</datalist>
			<datalist id="mlb-source-locations">
			</datalist>
			<datalist id="mlb-target-locations">
			</datalist>
			<div class="title">
				Mover posição inteira
			</div>
			<p class="mts muted">Transfere o saldo <strong>disponível</strong> (L) de cada lote na posição de origem para a posição de destino, <strong>sempre na mesma empresa</strong> (não há movimentação entre tenants). Se houver reserva ou bloqueio em alguma linha, o sistema <strong>não</strong> esvazia a posição: avisa, mostra referência de saída quando houver e pergunta se deseja movimentar <strong>somente o livre</strong> (reservado e bloqueado permanecem na origem).</p>
			<div class="fsb mtl">
				<label title="Depositante — origem e destino ficam neste tenant">Empresa<sup>*</sup>
					<input id="warehouse_company_id" class="company" type="text" list="mlb-companies" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Armazém de origem">Armazém origem<sup>*</sup>
					<input id="source_warehouse_id" class="warehouse" type="text" list="mlb-source-warehouses" required placeholder="Lista após empresa">
				</label>
				<label title="Posição de origem (endereço)">Posição origem<sup>*</sup>
					<input id="source_location_id" class="location" type="text" list="mlb-source-locations" required placeholder="Lista após armazém">
				</label>
				<span></span>
			</div>
			<div class="fsb">
				<label title="Armazém de destino">Armazém destino<sup>*</sup>
					<input id="target_warehouse_id" class="warehouse" type="text" list="mlb-target-warehouses" required placeholder="Lista após empresa">
				</label>
				<label title="Posição de destino">Posição destino<sup>*</sup>
					<input id="target_location_id" class="location" type="text" list="mlb-target-locations" required placeholder="Lista após armazém">
				</label>
				<span></span>
			</div>
			<div class="fsb">
				<label title="Motivo / observação (gravado nas transações)">Motivo<sup>*</sup>
					<input id="reason" type="text" required placeholder="Ex.: Relayout corredor">
				</label>
				<label title="Natureza registrada nas transações (padrão MOV)">Natureza
					<input id="movement_kind" type="text" list="movement_kind_list">
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class='bn_Escape button'>Fechar</button>
					<button type="button" class='bn_Enter button'>Executar</button>
				</span>
			</div>
		</form>
	`,

	form:
	{
		selector: '#move-location-bulk',
		init(formset)
		{
			formset.form.eraseValues();
			formset.loadList('#mlb-companies', 'companies', { labels: ['nick'], value: 'id' });
			Object.getPrototypeOf(this).init.call(this);
		},
	},

	fields: [
		{ properties: { selector: '#warehouse_company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#source_warehouse_id' }, types: [types.pubsub(), types.datalist(), types.observer('warehouse_company_id'), types.obs_load_options('warehouses')] },
		{ properties: { selector: '#target_warehouse_id' }, types: [types.pubsub(), types.datalist(), types.observer('warehouse_company_id'), types.obs_load_options('warehouses')] },
		{ properties: { selector: '#source_location_id' }, types: [types.pubsub(), types.datalist(), types.observer(['warehouse_company_id', 'source_warehouse_id']), types.obs_load_options('locations', { labels: ['address'], sep: '-', key: 'warehouse_company_id' })] },
		{ properties: { selector: '#target_location_id' }, types: [types.pubsub(), types.datalist(), types.observer(['warehouse_company_id', 'target_warehouse_id']), types.obs_load_options('locations', { labels: ['address'], sep: '-', key: 'warehouse_company_id' })] },
		{ properties: { selector: '#reason' }, types: [] },
		{ properties: { selector: '#movement_kind' }, types: [types.opt_movement_kind(), types.datalist()] },
	],

};
